import { render, staticRenderFns } from "./MoneyDisplay.vue?vue&type=template&id=7834ebe2&scoped=true&"
import script from "./MoneyDisplay.vue?vue&type=script&lang=ts&"
export * from "./MoneyDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MoneyDisplay.vue?vue&type=style&index=0&id=7834ebe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7834ebe2",
  null
  
)

export default component.exports